import { enumeration } from '@dazn/peng-html5-tools-utils';
var ApiServiceRequestHeaders = enumeration({
    ACCEPT: 'Accept',
    AUTHORIZATION: 'authorization',
    CONTENT_TYPE: 'Content-Type',
    DEBUG_LOG_ENABLED: 'debug-log-enabled',
    X_CORRELATION_ID: 'x-correlation-id',
    X_DAZN_DEVICE: 'x-dazn-device',
    X_DAZN_FORCE_DRM_PROVIDER: 'x-dazn-force-provider',
    X_DAZN_MARCO: 'x-dazn-marco',
    X_DRM_MODE: 'x-drm-mode',
    X_SESSION_ID: 'x-session-id',
});
export { ApiServiceRequestHeaders };
//# sourceMappingURL=ApiServiceRequestHeaders.js.map